var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 21.9913V18.5C15.1667 17.5654 15.1667 17.0981 14.9657 16.75C14.8341 16.522 14.6447 16.3326 14.4167 16.201C14.0686 16 13.6013 16 12.6667 16C11.7321 16 11.2648 16 10.9167 16.201C10.6887 16.3326 10.4993 16.522 10.3676 16.75C10.1667 17.0981 10.1667 17.5654 10.1667 18.5V21.9913H15.1667Z",
    fill: "url(#paint0_linear_869_7217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39873 12.0002C5.50795 12.0002 4.71992 11.6242 4.16669 11.0331V14.0002C4.16669 17.7715 4.16669 19.6571 5.33826 20.8287C6.28135 21.7718 7.68712 21.9557 10.1667 21.9915H15.1667C17.6463 21.9557 19.052 21.7718 19.9951 20.8287C21.1667 19.6571 21.1667 17.7715 21.1667 14.0002V11.0342C20.6135 11.6246 19.8259 12.0002 18.9356 12.0002C17.364 12.0002 16.0481 10.8093 15.8917 9.24548L15.8187 8.51758C16.0052 10.3822 14.5409 12.0002 12.667 12.0002C10.8057 12.0002 9.34859 10.404 9.51168 8.55536L9.44267 9.24548C9.28628 10.8093 7.97035 12.0002 6.39873 12.0002ZM15.1667 18.5002V21.9915H10.1667V18.5002C10.1667 17.5656 10.1667 17.0983 10.3676 16.7502C10.4993 16.5222 10.6887 16.3329 10.9167 16.2012C11.2648 16.0002 11.7321 16.0002 12.6667 16.0002C13.6013 16.0002 14.0686 16.0002 14.4167 16.2012C14.6447 16.3329 14.8341 16.5222 14.9657 16.7502C15.1667 17.0983 15.1667 17.5656 15.1667 18.5002Z",
    fill: "url(#paint1_linear_869_7217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1665 2H15.1665L15.8182 8.51737C16.0047 10.382 14.5404 12 12.6665 12C10.7925 12 9.32828 10.382 9.51475 8.51737L10.1665 2Z",
    fill: "url(#paint2_linear_869_7217)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3.99644 5.35133C4.17452 4.46093 4.26356 4.01573 4.4446 3.65484C4.82607 2.89439 5.51248 2.33168 6.33297 2.10675C6.72236 2 7.17637 2 8.0844 2H10.1667L9.44218 9.24527C9.2858 10.8091 7.96987 12 6.39824 12C4.46779 12 3.01993 10.2339 3.39852 8.34093L3.99644 5.35133Z",
    fill: "url(#paint3_linear_869_7217)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.337 5.35133C21.1589 4.46093 21.0698 4.01573 20.8888 3.65484C20.5073 2.89439 19.8209 2.33168 19.0004 2.10675C18.611 2 18.157 2 17.249 2H15.1667L15.8912 9.24527C16.0476 10.8091 17.3635 12 18.9352 12C20.8656 12 22.3135 10.2339 21.9349 8.34093L21.337 5.35133Z",
    fill: "url(#paint4_linear_869_7217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_869_7217",
    x1: 15.1667,
    y1: 18.9956,
    x2: 10.1667,
    y2: 18.9956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_869_7217",
    x1: 21.1667,
    y1: 15.2546,
    x2: 4.16669,
    y2: 15.2546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_869_7217",
    x1: 15.8342,
    y1: 7,
    x2: 9.49872,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_869_7217",
    x1: 10.1667,
    y1: 7,
    x2: 3.33807,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_869_7217",
    x1: 21.9953,
    y1: 7,
    x2: 15.1667,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016BDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/Shop.9463c223e3fdc17ff93f5ed5fee1e2f3.svg";
export { ForwardRef as ReactComponent };